import * as t from "io-ts";
import { BankAccount } from "./BankAccount";
import { CommExtras } from "./CommExtras";
import { ContactInfo } from "./ContactInfo";
import { Document } from "./Document";
import { FlowType } from "./FlowType";

export const CommContext = t.intersection([
  t.type({
    template_name: t.string,
    template: t.string,
    sender: ContactInfo,
    receiver: ContactInfo,
    deposit: t.type({
      original: t.string,
      applied: t.string,
      difference: t.string,
    }),
    bank_account: BankAccount,
    cta_url: t.string,
  }),
  t.partial({
    flow_type: FlowType,
    lender: ContactInfo,
    cta_sub_url: t.string,
    documents: t.array(Document),
    message: t.string,
    reference: t.string,
    subdomain: t.string,
    extras: CommExtras,
  }),
]);

export interface CommContext {
  template_name: string;
  template: string;
  flow_type?: FlowType;
  sender: ContactInfo;
  receiver: ContactInfo;
  lender?: ContactInfo;
  deposit: {
    original: string;
    applied: string;
    difference: string;
  };
  bank_account: BankAccount;
  cta_url: string;
  cta_sub_url?: string;
  documents?: Array<Document>;
  message?: string;
  reference?: string;
  subdomain?: string;
  extras?: CommExtras;
}
